/**
 * Capitalize all words of a string.
 * @param text The input text.
 * @returns The transformed text.
 */
export function capitalizeWords(text: string) {
    if (!text) {
        return "";
    }

    return text.replace(/(?:^|\s)\S/g, (a) => {
        return a.toUpperCase();
    });
}

/**
 * Prefixes all capitals with spaces.
 * @param text The input text.
 * @returns The transformed text.
 */
export function spaceCapitals(text: string) {
    if (!text) {
        return "";
    }

    return text
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/([A-Z]+)(?=[A-Z][a-z])/g, "$1 ")
        .trim();
}

export const connectorStateLabel = (state: string | undefined): string =>
    state === "FullyCharged" ? "Idle" : spaceCapitals(state ?? "Unknown");

/**
 * Convert text to sentence case (first letter capitalized, rest lowercase).
 * @param text The input text.
 * @returns The transformed text.
 */
export function sentenceCase(text: string) {
    if (!text) {
        return "";
    }

    const lowercased = text.toLowerCase();
    return `${lowercased.charAt(0).toUpperCase()}${lowercased.slice(1)}`;
}
